<template>
  <div class="settings-panel__container" v-if="internalValue">
    <div class="setting-section">
      <p class="setting-section__h">Позиция</p>
      <div class="setting-row">
        <label>Тип</label>
        <p><u>{{ fontTypeLabel }}</u></p>
      </div>
      <div class="setting-row">
        <label>ID</label>
        <p class="setting-row__p"><u>{{ internalValue.id }}</u></p>
        <button @click="copyId(internalValue.id)" class="modal-copy__button">
          <Icon svgClass="modal-copy__svg" name="copy" size="16" />
        </button>
      </div>
      <div class="setting-row">
        <button @click="deleteElement()" class="modal-delete__button">
          <Icon svgClass="modal-copy__svg" name="close" size="16" />
          Удалить
        </button>
      </div>
    </div>

    <div class="setting-section">
      <p class="setting-section__h">Текст</p>
      <div class="setting-row">
        <label>Шрифт</label>
        <FontSelect
          :activeFont="internalValue.settings?.font?.family || defaultFont.family"
          :options="{ name: 'main' }"
          @change="onFontChange"
        />
      </div>

      <div class="setting-row">
        <label class="label-row">Размер</label>
        <InputComponent
          type="number"
          :model-value="responsiveSettings.fontSize ?? defaultResponsive('fontSize')"
          @update:model-value="val => updateResponsiveOrSetting('fontSize', val)"
          suffix="rem"
          :min="0.1"
          :step="1"
          :max="150"
        />
      </div>

      <div class="setting-row">
        <label>Интерлиньяж</label>
        <InputComponent
          type="number"
          :model-value="responsiveSettings.lineHeight ?? defaultResponsive('lineHeight')"
          @update:model-value="val => updateResponsiveOrSetting('lineHeight', val)"
          suffix="rem"
          :min="0.1"
          :step="0.1"
          :max="150"
        />
      </div>

      <div class="setting-row">
        <label>Трекинг</label>
        <InputComponent
          type="number"
          :model-value="responsiveSettings.letterSpacing ?? defaultResponsive('letterSpacing')"
          @update:model-value="val => updateResponsiveOrSetting('letterSpacing', val)"
          suffix="rem"
          :min="0"
          :step="0.1"
          :max="150"
        />
      </div>
    </div>

    <div class="setting-section">
      <p class="setting-section__h">Отступы</p>
      <div class="setting-row">
        <label class="label-row">Внутренний</label>
        <div class="setting-column">
          <InputComponent
            v-for="(pad, idx) in iternalPadding"
            :key="'pad-'+idx"
            type="number"
            :model-value="iternalPadding[idx]"
            @update:model-value="val => updatePadding(val, idx)"
            suffix=""
            :min="0"
            :step="1"
            :max="150"
          />
        </div>
      </div>

      <div class="setting-row">
        <label class="label-row">Внешний</label>
        <div class="setting-column">
          <InputComponent
            v-for="(marg, idx) in iternalMargin"
            :key="'mar-'+idx"
            type="text"
            :model-value="iternalMargin[idx]"
            @update:model-value="val => updateMargin(val, idx)"
            suffix=""
            :step="1"
            :max="150"
          />
        </div>
      </div>
    </div>

    <div class="setting-section">
      <p class="setting-section__h">Размеры</p>
      <div class="setting-row">
        <label class="label-row">Ширина</label>
        <InputComponent
          type="text"
          :model-value="responsiveSettings.width ?? defaultResponsive('width')"
          @update:model-value="val => updateResponsiveOrSetting('width', val)"
          suffix="rem"
          :min="0"
          :step="1"
          :max="150"
        />
      </div>

      <div class="setting-row">
        <label class="label-row">Высота</label>
        <InputComponent
          type="text"
          :model-value="responsiveSettings.height ?? defaultResponsive('height')"
          @update:model-value="val => updateResponsiveOrSetting('height', val)"
          suffix="rem"
          :min="0"
          :step="1"
          :max="150"
        />
      </div>

      <div class="setting-row">
        <label class="label-row">Минимальная ширина</label>
        <InputComponent
          type="text"
          :model-value="responsiveSettings.minWidth ?? defaultResponsive('minWidth')"
          @update:model-value="val => updateResponsiveOrSetting('minWidth', val)"
          suffix="rem"
          :min="0"
          :step="1"
          :max="150"
        />
      </div>

      <div class="setting-row">
        <label class="label-row">Минимальная высота</label>
        <InputComponent
          type="text"
          :model-value="responsiveSettings.minHeight ?? defaultResponsive('minHeight')"
          @update:model-value="val => updateResponsiveOrSetting('minHeight', val)"
          suffix="rem"
          :min="0"
          :step="1"
          :max="150"
        />
      </div>

      <div class="setting-row">
        <label class="label-row">Максимальная ширина</label>
        <InputComponent
          type="text"
          :model-value="responsiveSettings.maxWidth ?? defaultResponsive('maxWidth')"
          @update:model-value="val => updateResponsiveOrSetting('maxWidth', val)"
          suffix="rem"
          :min="0"
          :step="1"
          :max="150"
        />
      </div>
      <div class="setting-row">
        <label class="label-row">Максимальная высота</label>
        <InputComponent
          type="text"
          :model-value="responsiveSettings.maxHeight ?? defaultResponsive('maxHeight')"
          @update:model-value="val => updateResponsiveOrSetting('maxHeight', val)"
          suffix="rem"
          :min="0"
          :step="1"
          :max="150"
        />
      </div>
    </div>

    <!-- Цвета -->
    <div class="setting-section">
      <p class="setting-section__h">Цвет</p>
      <div class="setting-row">
        <label>Фон</label>
        <ColorPicker
          :model-value="internalValue.settings?.backgroundColor"
          @update:model-value="val => updateSetting('backgroundColor', val)"
        />
      </div>
      <div class="setting-row">
        <label>Текст</label>
        <ColorPicker
          :model-value="internalValue.settings?.color"
          @update:model-value="val => updateSetting('color', val)"
        />
      </div>
    </div>

    <div class="setting-section">
      <label>Текст</label>
      <TextareaComponent
        :model-value="buttonText"
        @update:model-value="updateButtonText"
        :rows="2"
      />
    </div>

    <div class="setting-section">
      <p class="setting-section__h">Настройки группы</p>

      <div class="setting-row">
        <label class="label-row">Направление</label>
        <Multiselect
          :options="flexDirectionOptions"
          placeholder="Направление"
          :model-value="responsiveSettings.flexDirection ?? internalValue.settings?.flexDirection"
          @update:model-value="val => updateResponsiveOrSetting('flexDirection', val)"
        />
      </div>

      <div class="setting-row">
        <label class="label-row">По горизонтали</label>
        <Multiselect
          :options="justifyContentOptions"
          placeholder="Выравнивание"
          :model-value="responsiveSettings.justifyContent ?? internalValue.settings?.justifyContent"
          @update:model-value="val => updateResponsiveOrSetting('justifyContent', val)"
        />
      </div>

      <div class="setting-row">
        <label class="label-row">По вертикали</label>
        <Multiselect
          :options="alignItemsOptions"
          placeholder="Выравнивание"
          :model-value="responsiveSettings.alignItems ?? internalValue.settings?.alignItems"
          @update:model-value="val => updateResponsiveOrSetting('alignItems', val)"
        />
      </div>

      <div class="setting-row">
        <label class="label-row">Перенос</label>
        <Multiselect
          :options="flexWrapOptions"
          placeholder="Перенос"
          :model-value="responsiveSettings.flexWrap ?? internalValue.settings?.flexWrap"
          @update:model-value="val => updateResponsiveOrSetting('flexWrap', val)"
        />
      </div>
    </div>

    <div class="setting-section">
      <p class="setting-section__h">Иконка</p>
      <div class="setting-row">
        <label>Выбрать: </label>
        <IconPicker v-model="currentIcon" style="color:black" />
      </div>

      <div class="setting-row" v-if="iconChild">
        <label>Цвет</label>
        <ColorPicker
          :model-value="iconChild.settings?.color"
          @update:model-value="updateIconColor"
        />
      </div>

      <div class="setting-row" v-if="iconChild">
        <label>В начало</label>
        <Checkbox
          :model-value="isIconAtStart"
          @update:model-value="updateFlexDirection"
        />
      </div>

      <div class="setting-row" v-if="iconChild">
        <label class="label-row">Расстояние между</label>
        <InputComponent
          type="text"
          :model-value="responsiveSettings.gap ?? defaultResponsive('gap')"
          @update:model-value="val => updateResponsiveOrSetting('gap', val)"
          suffix="rem"
          :min="0"
          :step="0.5"
          :max="150"
        />
      </div>

      <div class="setting-column" v-if="iconChild">
        <button class="setting-delete__children" @click="removeIconChild">Удалить</button>
      </div>
    </div>

    <div class="setting-section">
      <label>Действия</label>
      <button class="setting-delete__children" @click="isOpenActionModal = true">Выбрать действие</button>
      <Modal v-model="isOpenActionModal">
        <template #header><h2 class="modal-header__h2">Выберите действия</h2></template>
        <PaginationList 
          :list="actionsList" 
          :selected-action="internalValue.action"
          @select-action="onActionSelect"
          @on-choose-element="onChooseElement"
        />
        <template #footer>
          <div class="modal-footer__left">
            <p class="modal-footer__p">Выбранное действие: {{internalValue?.action?.name}}</p>
          </div>
          <button @click="isOpenActionModal = false">Закрыть</button>
        </template>
      </Modal>

      <BottomModal v-model="isChoosing">
        <template #header>
          <Tooltip
            size="2"
            iconChar="?"
            circleBg="var(--blue-1)"
            iconColor="#fff"
            textAlign="center"
            tooltipText="Нажмите на элемент, <br>страница будет прокручиваться к нему"
          />
        </template>
        <div>
          <p class="modal-text__p" v-if="!choosedElement">Выберите любой элемент</p>
          <div class="modal-choosed__container" v-if="choosedElement">
            <div class="modal-choosed__element" ref="chosenElementContainer"></div>
          </div>
        </div>
        <template #footer>
          <button @click="acceptChoosedElement">Подтвердить</button>
          <button class="deny__button" @click="closeChooseModal">Отменить</button>
        </template>
      </BottomModal>
    </div>

  </div>
</template>

<script>
import FontSelect from "@/components/UI/Select/FontSelect.vue";
import IconPicker from "@/components/UI/Select/IconPicker.vue";
import InputComponent from "@/components/UI/Input/Input.vue";
import TextareaComponent from "@/components/UI/Input/Textarea.vue";
import ColorPicker from "@/components/UI/ColorPicker/index.vue";
import Checkbox from "@/components/UI/Select/Checkbox.vue";
import Modal from "@/components/UI/Modal/Modal.vue";
import BottomModal from "@/components/UI/Modal/BottomModal.vue";
import PaginationList from "@/components/UI/Lists/PaginationList.vue";
import Tooltip from "@/components/UI/Info/TooltipIcon.vue";
import Icon from '@/components/UI/Icon/Icon.vue';
import { screenSizes } from '@/config/screen-sizes.js'
import { mapGetters } from "vuex"
import { actionsList } from "@/config/actions-list.js";
import { safeClone } from '@/utils/clone.js';
import Multiselect from "@/components/UI/Select/Multiselect.vue";
import { 
  flexDirectionOptions, 
  justifyContentOptions, 
  alignItemsOptions, 
  flexWrapOptions 
} from '@/config/flex-options.js';

import {
  idGenerator,
  normalizeSpacingVal,
  buildSpacingString
} from '@/utils/blocks/block-settings-utils.js';

export default {
  name: "DivSettings",
  components: { FontSelect, IconPicker, InputComponent, TextareaComponent, ColorPicker, Checkbox, Modal, BottomModal, PaginationList, Tooltip, Multiselect, Icon },
  props: {
    internalValue: { type: Object, required: true }
  },
  emits: ['update:internal-value'],
  data() {
    return {
      defaultFont: { family: "Roboto" },
      currentIcon: '',
      isOpenActionModal: false,
      isOpenChooseModal: false,
      actionsList,
      iternalPadding: ['', '', '', ''],
      iternalMargin: ['', '', '', ''],
      flexDirectionOptions, 
      justifyContentOptions, 
      alignItemsOptions, 
      flexWrapOptions,
    };
  },
  computed: {
    ...mapGetters("landing", ["landingSettings"]),
    fontTypeLabel() { return "Родительский" },
    currentScreenSize() {
      const w = this.landingSettings?.size?.width;
      if (!w) return null;
      const ind = screenSizes?.find(item => item.title === String(w) + 'px');
      return ind ? ind.title.replace('px','') : null;
    },
    isChoosing () { return this.$store.getters['choosedElement/isChoosing'] },
    choosedElement () { return this.$store.getters['choosedElement/choosedElement'] },
    iconChild() {
      return this.internalValue?.children?.data?.find(c => c.classes?.includes('icon')) || null;
    },
    buttonText() {
      const textChild = this.internalValue?.children?.data?.find(c => c.classes?.includes('button-text'));
      return textChild?.data ?? this.internalValue?.data ?? '';
    },
    isIconAtStart() {
      return this.iconChild?.settings?.flex?.id === 1;
    },
    responsiveSettings() {
      const br = this.currentScreenSize;
      if (!this.internalValue || !this.internalValue.settings) return {};
      const resp = this.internalValue.settings.responsive;
      if (!resp || typeof resp !== 'object') return {};
      return (br && resp[br]) ? resp[br] : {};
    }
  },
  watch: {
    landingSettings: { handler () { this.syncSpacing(); }, deep: true },
    choosedElement: { immediate: true, handler() { this.$nextTick(() => { this.renderChoosedElement(); }); } },
    currentScreenSize(newVal, oldVal) { this.syncSpacing(); },
    currentIcon(newVal) { if (newVal) this.addOrReplaceIconChild(newVal); else this.removeIconChild(); },
    internalValue: { immediate: true, handler() { this.currentIcon = this.iconChild?.classes?.[1] || ''; this.syncSpacing(); } },
    iternalPadding: { deep: true, handler() {} }
  },
  methods: {
    emitUpdated(newObj) { this.$emit('update:internal-value', safeClone(newObj)); },

    async deleteElement () {
      const id = this.internalValue?.id; if (!id) return;
      const ok = window.confirm('Удалить элемент и все его дочерние элементы?'); if (!ok) return;
      try {
        await this.$store.dispatch('landing/DELETE_ELEMENT', id);
        try { this.$store.dispatch('activeElement/UPDATE_ACTIVE_ELEMENT', null); } catch(e){}
        try { this.$store.dispatch('choosedElement/UPDATE_CHOOSED_ELEMENT', null); } catch(e){}
        this.emitUpdated(null);
      } catch (err) { console.error('deleteElement failed', err); }
    },

    copyId (text) {
      if (!text) return Promise.resolve();
      if (navigator.clipboard && window.isSecureContext) return navigator.clipboard.writeText(text);
      const ta = document.createElement('textarea'); ta.value = text; ta.style.position = 'fixed'; ta.style.left = '-9999px'; document.body.appendChild(ta); ta.focus(); ta.select();
      try { document.execCommand('copy'); } catch (e) {}
      document.body.removeChild(ta); return Promise.resolve();
    },

    syncSpacing() {
      const defaultArr = ['', '', '', ''];
      if (!this.internalValue || !this.internalValue.settings) { this.iternalPadding = defaultArr.slice(); this.iternalMargin = defaultArr.slice(); return; }
      const br = this.currentScreenSize;
      const resp = this.internalValue.settings?.responsive;
      const paddingSource = (br && resp && resp[br] && resp[br].padding) ?? this.internalValue.settings.padding;
      const marginSource = (br && resp && resp[br] && resp[br].margin) ?? this.internalValue.settings.margin;
      this.iternalPadding = normalizeSpacingVal(paddingSource);
      this.iternalMargin = normalizeSpacingVal(marginSource);
      while (this.iternalPadding.length < 4) this.iternalPadding.push('');
      while (this.iternalMargin.length < 4) this.iternalMargin.push('');
    },

    buildSpacingString(arr) { return buildSpacingString(arr); },

    updatePadding(val, indx) {
      const parsed = (val === '' || val === null || val === undefined) ? null : Number(val);
      this.iternalPadding.splice(indx, 1, parsed);
      const paddingString = this.buildSpacingString(this.iternalPadding);
      if (this.currentScreenSize) this.updateResponsiveSetting(this.currentScreenSize, 'padding', paddingString === undefined ? undefined : paddingString);
      else this.updateSetting('padding', paddingString === undefined ? undefined : paddingString);
    },

    updateMargin(val, indx) {
      const parsed = (val === '' || val === null || val === undefined) ? null : Number(val);
      this.iternalMargin.splice(indx, 1, parsed);
      const marginString = this.buildSpacingString(this.iternalMargin);
      if (this.currentScreenSize) this.updateResponsiveSetting(this.currentScreenSize, 'margin', marginString === undefined ? undefined : marginString);
      else this.updateSetting('margin', marginString === undefined ? undefined : marginString);
    },

    renderChoosedElement() {
      const container = this.$refs.chosenElementContainer; if (!container) return; container.innerHTML = '';
      if (!this.choosedElement) return; const el = document.getElementById(this.choosedElement); if (!el) return;
      document.querySelectorAll('[data-choosed="true"]').forEach(node => { node.style.outline = ''; node.removeAttribute('data-choosed'); });
      el.style.outlineColor = 'var(--blue-2)'; el.style.outlineWidth = '2px'; el.style.outlineStyle = 'dashed'; el.setAttribute('data-choosed', 'true');
      container.textContent = `Выбран элемент: #${this.choosedElement}`;
    },

    acceptChoosedElement () { this.$store.dispatch('choosedElement/UPDATE_CHOOSING', false); const prev = document.querySelector('[data-choosed="true"]'); if (prev) { prev.style.outline = ''; prev.removeAttribute('data-choosed'); } this.isOpenActionModal = true },
    closeChooseModal() { this.$store.dispatch('choosedElement/UPDATE_CHOOSING', false); const prev = document.querySelector('[data-choosed="true"]'); if (prev) { prev.style.outline = ''; prev.removeAttribute('data-choosed'); } this.$store.dispatch('choosedElement/UPDATE_CHOOSED_ELEMENT', null); this.isOpenActionModal = false },
    
    onChooseElement (data) { 
      this.$store.dispatch('choosedElement/UPDATE_CHOOSING', true); 
      this.isOpenActionModal = false 
    },

    onActionSelect(action) {
      if (!action) return; const newVal = safeClone(this.internalValue || {});
      newVal.action = { id: action.id, name: action.name, slug: action.slug || null, functionName: action.functionName || null, data: action.data ? safeClone(action.data) : [] };
      this.emitUpdated(newVal);
    },

    updateButtonText(newText) {
      const newVal = safeClone(this.internalValue || {});
      if (!newVal.children) newVal.children = { id: idGenerator(), data: [] };
      if (!Array.isArray(newVal.children.data)) newVal.children.data = [];
      let textChild = newVal.children.data.find(c => c.classes?.includes('button-text'));
      if (!textChild) {
        textChild = { id: idGenerator(), number: 0, tag: 'span', title: 'Текст', classes: ['button-text'], data: newText, settings: { size: 1, lineHeight: 1, letterSpacing: 0 } };
        newVal.children.data.unshift(textChild);
      } else { textChild.data = newText; }
      newVal.data = '';
      this.emitUpdated(newVal);
    },

    addOrReplaceIconChild(iconClass) {
      const newVal = safeClone(this.internalValue || {});
      if (!newVal.children) newVal.children = { id: idGenerator(), data: [] };
      if (!Array.isArray(newVal.children.data)) newVal.children.data = [];
      const idx = newVal.children.data.findIndex(c => c.classes?.includes('icon'));
      const existing = idx !== -1 ? newVal.children.data[idx] : null;
      const iconChild = { id: existing?.id || idGenerator(), number: newVal.children.data.length, tag: 'i', title: 'Иконка', classes: ['icon', iconClass], data: [], settings: {} };
      if (idx !== -1) newVal.children.data[idx] = iconChild; else newVal.children.data.push(iconChild);
      this.emitUpdated(newVal);
    },

    updateIconColor(val) {
      if (!this.iconChild) return; const newVal = safeClone(this.internalValue || {});
      const idx = newVal.children.data.findIndex(c => c.id === this.iconChild.id); if (idx === -1) return;
      if (!newVal.children.data[idx].settings) newVal.children.data[idx].settings = {};
      newVal.children.data[idx].settings.color = val; this.emitUpdated(newVal);
    },

    updateFlexDirection(atStart) {
      if (!this.iconChild) return;
      const newVal = safeClone(this.internalValue || {});
      // Update container direction depending on icon position
      if (!newVal.settings) newVal.settings = {};
      newVal.settings.flexDirection = atStart ? 'row-reverse' : 'row';

      const idx = newVal.children.data.findIndex(c => c.id === this.iconChild.id);
      if (idx === -1) { this.emitUpdated(newVal); return; }
      if (!newVal.children.data[idx].settings) newVal.children.data[idx].settings = {};
      if (!newVal.children.data[idx].settings.flex) newVal.children.data[idx].settings.flex = {};
      newVal.children.data[idx].settings.flex.id = atStart ? 1 : 0;
      this.emitUpdated(newVal);
    },

    removeIconChild() {
      if (!this.iconChild) return; const newVal = safeClone(this.internalValue || {});
      newVal.children.data = newVal.children.data.filter(c => c.id !== this.iconChild.id);
      this.emitUpdated(newVal); this.currentIcon = '';
    },

    updateSetting(key, value) {
      const newVal = safeClone(this.internalValue || {});
      if (!newVal.settings) newVal.settings = {};
      if (value === null || value === undefined) delete newVal.settings[key]; else newVal.settings[key] = value;
      this.emitUpdated(newVal);
    },

    updateResponsiveSetting(breakpointKey, prop, value) {
      const newVal = safeClone(this.internalValue || {});
      if (!newVal.settings) newVal.settings = {};
      if (!newVal.settings.responsive || typeof newVal.settings.responsive !== 'object') newVal.settings.responsive = {};
      if (!newVal.settings.responsive[breakpointKey] || typeof newVal.settings.responsive[breakpointKey] !== 'object') newVal.settings.responsive[breakpointKey] = {};
      const parsedValue = value === null || value === undefined ? undefined : value;
      if (parsedValue === undefined) {
        delete newVal.settings.responsive[breakpointKey][prop];
        if (Object.keys(newVal.settings.responsive[breakpointKey]).length === 0) delete newVal.settings.responsive[breakpointKey];
      } else {
        newVal.settings.responsive[breakpointKey][prop] = parsedValue;
      }
      if (newVal.settings.responsive && Object.keys(newVal.settings.responsive).length === 0) delete newVal.settings.responsive;
      this.emitUpdated(newVal);
    },

    updateResponsiveOrSetting(prop, value) {
      if (this.currentScreenSize) this.updateResponsiveSetting(this.currentScreenSize, prop, value);
      else this.updateSetting(prop, value);
    },

    defaultResponsive(prop) {
      return this.internalValue?.settings?.[prop] ?? '';
    }
  }
};
</script>

<style scoped>
.setting-section { padding-bottom:0.5rem; margin-top:0.5rem; border-bottom:0.1rem solid var(--grey-0); display:flex; flex-direction:column; gap:0.5rem; }
.setting-row { display:flex; align-items:center; gap:0.5rem; }
.setting-column { display:flex; flex-direction:column; gap:0.5rem; width: 100%; }
.setting-section__h { text-align:start; font-weight:bold; }
.setting-delete__children { width: fit-content; }
.modal-choosed__container {
  width: 27rem;
  overflow: hidden;
  border-radius: 0.2rem;
}
.modal-choosed__element {
  overflow: scroll;
  height: 100%;
  width: 100%;
  text-wrap: nowrap;
}
.modal-header__h2 {
  font-size: 1.5rem;
  text-align: left;
}
.modal-footer__p {
  text-align: left;
}
.label-row {
  text-wrap: nowrap;
}
.setting-row__p {
  text-align: left;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}
.modal-copy__svg {
  width: 1rem;
  height: 1rem;
}
.modal-copy__button {
  padding: 0;
  color: white;
  background-color: transparent;
  border: 0.1rem solid var(--color-0);
  padding: 0.2rem;
}
::v-deep(.setting-row > .multiselect__main > .multiselect > .multiselect__tags) {
  width: auto !important;
  text-wrap: nowrap !important;
  .multiselect__single {
    color: white;
    font-weight: 100;
  }
}
.modal-delete__button {
  padding: 0;
  color: white;
  background-color: transparent;
  border: 0.1rem solid var(--color-0);
  padding: 0.2rem;
}

</style>
